import { Snowplow2StatsSchemaEventInterface } from '../schema-event.interface';
import { Snowplow2StatsSchemaContextInterface } from '../schema-context.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsAdapterSchemaLayoutContext } from '../adapter/schema-layout-context';

export class Snowplow2StatsDataTrackable {
  protected eventSchema: Snowplow2StatsSchemaEventInterface | null = null;
  protected contextSchemaList: Snowplow2StatsSchemaContextInterface[] = [];

  /**
   *
   * @param context
   */
  constructor(context: StatsContextInterface) {
    // Layout context
    this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaLayoutContext(context).getData());
  }

  /**
   * Sets the event schema
   *
   * @param eventSchema
   */
  public setEventSchema(eventSchema: Snowplow2StatsSchemaEventInterface | null): void {
    this.eventSchema = eventSchema;
  }

  /**
   * Returns the list of context schemas
   */
  public getContextSchemaList(): Snowplow2StatsSchemaContextInterface[] {
    return this.contextSchemaList;
  }

  /**
   * Returns the event schema
   */
  public getEventSchema(): Snowplow2StatsSchemaEventInterface | null {
    return this.eventSchema;
  }
}
